import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators, FormArray, FormBuilder, ValidatorFn } from '@angular/forms';
import { BasicQuestionComponent } from '../../../shared/modal/basic-question/basic-question.component';
import { GlobalService } from '../../../services/global.service';
import { SnackBarService } from '../../../shared/snackbar/snackbar.service';
import Utils from '../../../shared/utility';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  public profileImage: string;
  profileForm: FormGroup;
  resetPassForm: FormGroup;
  isResetPassword: boolean = false;
  hidePass: boolean = true;
  displayCancelBtn: boolean = false;
  data;

  constructor(@Inject(MAT_DIALOG_DATA) data, private matDialog: MatDialog, private dialogRef: MatDialogRef<ProfileComponent>, private globalService: GlobalService, private snackBarService: SnackBarService, private formBuilder: FormBuilder) {
    console.log('data passed', data);
    //HACK: need a dynamic check here
    this.globalService.isSSOUser = localStorage.getItem("email").includes("_nw");
    this.displayCancelBtn = localStorage.getItem('isPaying') == 'true';
    this.data = data;
  }

  ngOnInit() {
    this.profileImage = localStorage.getItem('profilePhotoPath') !== 'null' ? this.globalService.assetURL + localStorage.getItem('profilePhotoPath') : 'https://web234.hvsfinancial.com/portal/assets/images/users/anon_user.png';
  
    this.profileForm = this.formBuilder.group({
      firstName: [this.data.firstName, [Validators.required, Validators.minLength(2), Validators.maxLength(30), Validators.pattern('^[a-zA-Z \-\']+')]],
      lastName: [this.data.lastName, [Validators.required, Validators.minLength(2), Validators.maxLength(30), Validators.pattern('^[a-zA-Z \-\']+')]],
      phone: [this.data.phone, [Validators.required, Validators.minLength(14), Validators.maxLength(14)]]
    });
  }

  resetPassword(){
    this.isResetPassword = true;
    this.resetPassForm = this.formBuilder.group({
      currentPass: ['', Validators.required],
      newPass: ['', Validators.required],
      newPassConfirmed: ['', Validators.required]
    });

  }

  updatePassword(){
    //this.isResetPassword = false;

    //TODO: call the reset password endpoint here
    var UserModel = {
      Password: this.resetPassForm.value.newPassConfirmed
    }
    this.globalService.resetPassword(UserModel)
    .subscribe(
      data => {        
        this.snackBarService.add('Your password has been updated.', 0);
        this.close();
      },
      error => {
        //this.error = <any>error;
        this.close();
      });   
  }

  save() {
    var UserModel = {
      UserID: Number(localStorage.getItem('userId')),
      FirstName: this.profileForm.value.firstName,
      LastName: this.profileForm.value.lastName,
      Phone: this.profileForm.value.phone,
    }

    console.log('profile obj', UserModel);
    this.globalService.updateAdvisor(UserModel)
      .subscribe(
        data => {
          if (data) {
            localStorage.setItem('firstName', UserModel.FirstName);
            localStorage.setItem('lastName', UserModel.LastName);
            localStorage.setItem('phone', UserModel.Phone);
          }

          this.snackBarService.add('Your profile has been updated.', 0);
          this.close();
        },
        error => {
          //this.error = <any>error;
          this.close();
        });    
  }

  uploadProfilePicture(e) {
    let file: File = e.target.files[0];
    let formData: FormData = new FormData();
    var date = new Date().getTime() / 1000;
    formData.append('uploadFile', file, file.name);
    formData.append('Email', this.data.email);
    formData.append('UserID', localStorage.getItem('userId'));
    this.globalService.saveProfileImage(formData)
      .subscribe(
        data => {
          localStorage.setItem('profilePhotoPath', data._body);
          this.profileImage = this.globalService.assetURL + localStorage.getItem('profilePhotoPath');

          this.snackBarService.add('Your profile picture has been added successfully.', 0);
        });
        //,
        //error => this.error = <any>error);

  }

  formatToString(section){  
    if(section == 'firstName'){
      this.profileForm.controls['firstName'].patchValue(Utils.formatToString(this.profileForm.value.firstName));
    } else if(section == 'lastName'){
      this.profileForm.controls['lastName'].patchValue(Utils.formatToString(this.profileForm.value.lastName));
    }
  }

  onPhoneInputChange(event, backspace) {
    let newVal = event.replace(/\D/g, '');
    if (backspace && newVal.length <= 6) {
      newVal = newVal.substring(0, newVal.length - 1);
    }
    if (newVal.length === 0) {
      newVal = '';
    } else if (newVal.length <= 3) {
      newVal = newVal.replace(/^(\d{0,3})/, '($1)');
    } else if (newVal.length <= 6) {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})/, '($1) $2');
    } else if (newVal.length <= 10) {
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
    } else {
      newVal = newVal.substring(0, 10);
      newVal = newVal.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
    }
    //this.ngControl.valueAccessor.writeValue(newVal);
    this.profileForm.controls["phone"].setValue(newVal);  
  }

  close() {
      this.dialogRef.close();
  }

  submitCancellation() {
    const dialogRef = this.matDialog.open(BasicQuestionComponent, {     
      data: { title: 'Notification!', 
      btnNoTitle: 'No! I want to keep my account!',
      btnYesTitle: 'Yes. Please cancel my account.',
      question: 'Are you sure you want to close your account?' }
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result){
        this.finalizeCancellation();
      }
    });  
  }

  finalizeCancellation(){
    this.snackBarService.add('Your cancellation request has been sent to our Support Team. Please allow 1-2 business days for your account to be closed, <br/>after which no additional charges will be issued. You will receive any additional correspondence via email.', 0, 0, 15000);
    
    this.close();

    var SupportModel = {
      AdvisorID: Number(localStorage.getItem('selectedAdvisorID')),
      OrgID: Number(localStorage.getItem('orgID')),
      Subject: "Cancellation Request",
      Message: "User has clicked the Cancel Subscription button in their profile. Please close out this account and stop all charges."
    }

    this.globalService.createSupportTicket(SupportModel)
      .subscribe(
        data => { });
        //,error => this.error = <any>error);
  }
}
